<div class="cases-popup-backdrop" (click)="onClose()">
  <div class="cases-popup" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="popup-header">
      <div>
        <div class="popup-label">Linked Cases</div>
        <div class="popup-title">{{ title() }}</div>
        @if (subtitle()) {
          <div class="popup-subtitle">{{ subtitle() }}</div>
        }
      </div>
      <button class="popup-close" (click)="onClose()">
        <span>&times;</span>
      </button>
    </div>

    <!-- Content -->
    <div class="popup-content">
      @if (sortedCases().length > 0) {
        @for (c of sortedCases(); track c.request_id) {
          <div class="case-row">
            <div class="case-row-header">
              <div class="d-flex align-items-center gap-2">
                <span class="case-id">#{{ c.request_id }}</span>
                <span [class]="'severity-badge severity-' + c.priority.toLowerCase()">
                  {{ c.priority }}
                </span>
              </div>
              <span class="case-date">{{ c.created_time | date: 'MMM d, y, h:mm a' }}</span>
            </div>
            <div class="case-subject">{{ c.subject }}</div>
            <div class="case-meta">
              <div class="meta-item">
                <span class="meta-label">Type</span>
                <span class="meta-value">{{ c.issue_type }}</span>
              </div>
              <div class="meta-item">
                <span class="meta-label">Source</span>
                <span class="meta-value">{{ c.ticket_source }}</span>
              </div>
              <div class="meta-item">
                <span class="meta-label">Status</span>
                <span class="meta-value">{{ c.ticket_status ?? 'Pending' }}</span>
              </div>
              <div class="meta-item">
                <span class="meta-label">Disposition</span>
                <span class="meta-value">{{ c.customer_defined_status }}</span>
              </div>
            </div>
            <div class="case-ips">
              <span class="ip-label">SRC</span>
              <span class="ip-value">{{ c.source_ip_address_hostname_mac }}</span>
              <span class="ip-arrow">&rarr;</span>
              <span class="ip-label">DST</span>
              <span class="ip-value">{{ c.destination_ip_address_hostname_mac }}</span>
            </div>
          </div>
        }
      } @else {
        <div class="empty-state">No linked cases for this risk check.</div>
      }
    </div>

    <!-- Footer -->
    @if (sortedCases().length > 0) {
      <div class="popup-footer">
        <span class="footer-count">
          Showing {{ sortedCases().length }} case{{ sortedCases().length !== 1 ? 's' : '' }}
        </span>
      </div>
    }
  </div>
</div>
